import { Suspense } from 'react';
import StrapiFeaturedArticlesSkeleton from './StrapiFeaturedArticlesSkeleton';
import StrapiFeaturedArticlesSuspended, {
	StrapiFeaturedArticlesSuspendedProps,
} from './StrapiFeaturedArticlesSuspended';

const StrapiFeaturedArticles = (
	props: StrapiFeaturedArticlesSuspendedProps,
) => {
	return (
		<Suspense fallback={<StrapiFeaturedArticlesSkeleton />}>
			<StrapiFeaturedArticlesSuspended {...props} />
		</Suspense>
	);
};

export default StrapiFeaturedArticles;
